export enum ErrorCode {
  EmailWithCorporateDomain = 1,
  InvalidEmail = 4,
  TrialQuotaExceeded = 7,
  EmailAlreadyRegistered = 9,
  PhoneAlreadyRegistered = 10,
  PhoneAndEmailAlreadyRegistered = 11,
  UserAlreadyRegistered = 12,
  DuplicateMedia = 18,
  InvalidChallengeStatus = 19,
}
